const CONNECTRIA_DOMAIN = 'tria.connectria.com',
  hostname = window.location.hostname,
  LIGHTEDGE_DOMAIN = 'mylightedge.com';

let ACCOUNTS_API = 'https://accounts-dev.' + CONNECTRIA_DOMAIN,
  ACCOUNTS_URL = 'https://dev.accounts.' + LIGHTEDGE_DOMAIN,
  LOGIN_URL = 'https://dev.login.mylightedge.com/',
  ENV = 'dev',
  DOMAIN = 'dev.' + CONNECTRIA_DOMAIN,
  AWS_IDENTITY_POOL_ID = 'us-east-1:2e6d0ea2-1e08-476e-a6df-c4ee1981821b',
  AWS_USER_POOL_ID = 'us-east-1_MVORKBzco',
  AWS_POOL_CLIENT_ID = '1hjh7o0a1l4mem9ac0n968cim2',
  ACCOUNTS_CDK_URL = 'https://m4ba59ez96.execute-api.us-east-1.amazonaws.com/prod';

if (hostname.indexOf('labs.demo.') > -1) {
  ENV = 'qa';
  ACCOUNTS_API = 'https://accounts-demo.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_URL = 'https://accounts.demo.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_CDK_URL = 'https://88cn5hx1mb.execute-api.us-east-1.amazonaws.com/prod';
  AWS_IDENTITY_POOL_ID = 'us-east-1:38abc155-0555-4f34-92dd-7d76b0aae10b';
  AWS_USER_POOL_ID = 'us-east-1_vlVCSH4IH';
  AWS_POOL_CLIENT_ID = '213k84a2ftsbhda9i2v7eo9rpp';
}
if (hostname.indexOf('qa.tria') > -1) {
  ENV = 'qa';
  ACCOUNTS_API = 'https://accounts-qa.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_URL = 'https://accounts.qa.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_CDK_URL = 'https://88cn5hx1mb.execute-api.us-east-1.amazonaws.com/prod';
}
if (hostname.indexOf('tria-labs.connectria') > -1) {
  ENV = 'prod';
  ACCOUNTS_API = 'https://accounts-api.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_URL = 'https://accounts.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_CDK_URL = 'https://60171yaac5.execute-api.us-east-1.amazonaws.com/prod';

  AWS_IDENTITY_POOL_ID = 'us-east-1:f384b212-4e86-4009-a6ff-850feaf47b7c';
  AWS_USER_POOL_ID = 'us-east-1_pccC7Xpyj';
  AWS_POOL_CLIENT_ID = '6pubecksk09peb69m3mr31mns1';
}
if (hostname === 'portal.mylightedge.com' || hostname === 'clone.portal.mylightedge.com') { // hostname.indexOf('portal.mylightedge') > -1 || hostname.indexOf('clone.portal.mylightedge') > -1
  ENV = 'prod';
  DOMAIN = CONNECTRIA_DOMAIN;
  LOGIN_URL = 'https://login.' + LIGHTEDGE_DOMAIN;
  ACCOUNTS_API = 'https://accounts-api.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_URL = 'https://accounts.' + LIGHTEDGE_DOMAIN;
  ACCOUNTS_CDK_URL = 'https://60171yaac5.execute-api.us-east-1.amazonaws.com/prod';

  AWS_IDENTITY_POOL_ID = 'us-east-1:f384b212-4e86-4009-a6ff-850feaf47b7c';
  AWS_USER_POOL_ID = 'us-east-1_pccC7Xpyj';
  AWS_POOL_CLIENT_ID = '6pubecksk09peb69m3mr31mns1';
}
if (hostname.indexOf('labs-prod.tria') > -1) {
  ENV = 'prod';
  DOMAIN = CONNECTRIA_DOMAIN;
  ACCOUNTS_API = 'https://accounts-api.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_URL = 'https://accounts.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_CDK_URL = 'https://60171yaac5.execute-api.us-east-1.amazonaws.com/prod';

  AWS_IDENTITY_POOL_ID = 'us-east-1:f384b212-4e86-4009-a6ff-850feaf47b7c';
  AWS_USER_POOL_ID = 'us-east-1_pccC7Xpyj';
  AWS_POOL_CLIENT_ID = '6pubecksk09peb69m3mr31mns1';
}
if (hostname.indexOf('uat.portal.mylightedge') > -1 || hostname.indexOf('uatlocal.portal.mylightedge') > -1) {
  ENV = 'qa';
  DOMAIN = CONNECTRIA_DOMAIN;
  LOGIN_URL = 'https://uat.login.' + LIGHTEDGE_DOMAIN;
  ACCOUNTS_API = 'https://accounts-staging.' + CONNECTRIA_DOMAIN;
  ACCOUNTS_URL = 'https://uat.accounts.' + LIGHTEDGE_DOMAIN;
  ACCOUNTS_CDK_URL = 'https://88cn5hx1mb.execute-api.us-east-1.amazonaws.com/prod';

  AWS_IDENTITY_POOL_ID = 'us-east-1:38abc155-0555-4f34-92dd-7d76b0aae10b';
  AWS_USER_POOL_ID = 'us-east-1_vlVCSH4IH';
  AWS_POOL_CLIENT_ID = '2qg3lh6le299vd66osvbeeceag';
}
if (hostname.indexOf('localhost') > -1) {
  DOMAIN = 'localhost';
  ACCOUNTS_API = 'http://localhost:3000';
}

console.log('Domain', DOMAIN);

// Analytics constants (moved from analytics-loader.js)
const ANALYTICS_PROD_HOST = 'next-gen.tria.connectria.com';
const ANALYTICS_PROD_UA = 'UA-154477883-1';
const ANALYTICS_DEV_UA = 'UA-154477883-2';

export { ACCOUNTS_API, ACCOUNTS_URL, DOMAIN, ENV, AWS_IDENTITY_POOL_ID, AWS_USER_POOL_ID, AWS_POOL_CLIENT_ID, LOGIN_URL, LIGHTEDGE_DOMAIN, ACCOUNTS_CDK_URL, ANALYTICS_PROD_HOST, ANALYTICS_PROD_UA, ANALYTICS_DEV_UA };
